import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=16b1a9b9&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=16b1a9b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1a9b9",
  null
  
)

export default component.exports